<div class="checkbox-field">
  <input
    type="checkbox"
    class="checkbox"
    tabindex="0"
    [attr.id]="fieldId"
    [formControl]="fieldControl"
  />

  <app-icon
    *ngIf="icon"
    class="icon checkbox-icon"
    [icon]="icon"
    (click)="onClickIcon.emit()"
  >
  </app-icon>

  <label
    class="checkbox-label"
    [ngClass]="{
      'hidden-label': hideLabel,
      disabled: fieldControl?.disabled
    }"
    [attr.for]="fieldId"
    [attr.data-e2e-id]="e2eId"
    (click)="fieldControl?.enabled && onClick.emit($event)"
  >
    <span *ngIf="label" [ngClass]="{ 'sr-text': hideLabel }">
      {{ label }}
    </span>
  </label>
</div>

<app-error-message
  class="error-message"
  [fieldControl]="fieldControl"
  [errorMessage]="errorMessage"
>
</app-error-message>

<p *ngIf="description" class="description">
  {{ description }}
</p>
